import { lazy } from "react";

const LeadersOfHub = lazy(() => import("../Component/Employee/LeadersOfHub"));
const AttendanceList = lazy(() => import("../Component/Attendance/AttendanceList"));
const WorkStatus = lazy(() => import("../Component/ManageEmployee/WorkStatus"));
const PersonalDetails = lazy(() => import("../Component/Recommendation/PersonalDetails"));
const EmployeeDetails = lazy(() => import("../Component/ManageEmployee/EmployeeDetails"));
const VacancyList = lazy(() => import("../Component/ManageEmployee/VacancyList"));

const employeeRoutes = [
  { path: "/leader-of-hub", element: <LeadersOfHub />, protected: true },
  { path: "/manage-employee-attendance-list", element: <AttendanceList />, protected: true },
  { path: "/manage-work-status", element: <WorkStatus />, protected: true },
  { path: "/candidate-personal-detail/:id", element: <PersonalDetails />, protected: true },
  { path: "/employee-detail/:id", element: <EmployeeDetails />, protected: true },
  { path: "/vacancy-list", element: <VacancyList />, protected: true },
];

export default employeeRoutes;
